export const INITIATED = 'INITIATED';
export const VERIFIED_EMAIL = 'VERIFIED EMAIL';
export const APPROVED = 'APPROVED';
export const LEGAL_ENTITY = 'LEGAL ENTITY';
